// Do not add more, here should only exist de environment

const env: string = process.env.REACT_APP_ENVIRONMENT || 'prod';

export { env };
